<a [routerLink]="getRouterLink()" [ngClass]="{'active-link': active}">
  <ng-content></ng-content>
  <span *ngIf="addShopModule!==0">{{shopService.getShopModuleName(mainService.ctxMain, addShopModule)}}</span>
</a>
